import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { environment } from '@env'
import { OAuthResponse, UserData } from '@models/oauth.models'

const { endpoint, authorization } = environment

@Injectable({
	providedIn: 'root',
})
export class AuthServices {
	constructor(private readonly http: HttpClient) {}

	oAuth(username: string, requestPoint: string, password: string): Observable<UserData> {
		const url = `${endpoint}/security/oauth/token`
		const body: HttpParams = new HttpParams()
			.set('username', username)
			.set('request_point', requestPoint)
			.set('password', password)
			.set('grant_type', 'password')
			.set('type', 'app_partner')
		const headers = new HttpHeaders()
			.set('Content-Type', 'application/x-www-form-urlencoded')
			.set('Authorization', authorization)

		return this.http.post<OAuthResponse>(url, body, { headers }).pipe(
			map(({ access_token, refresh_token, metadata }) => ({
				requestPoint,
				access_token,
				refresh_token,
				metadata,
			}))
		)
	}

	refreshToken(refreshToken: string, requestPoint: string): Observable<UserData> {
		const url = `${endpoint}/security/oauth/token`
		const body: HttpParams = new HttpParams()
			.set('request_point', requestPoint)
			.set('refresh_token', refreshToken)
			.set('grant_type', 'refresh_token')
			.set('type', 'app_partner')
		const headers = new HttpHeaders()
			.set('Content-Type', 'application/x-www-form-urlencoded')
			.set('Authorization', authorization)

		return this.http.post<OAuthResponse>(url, body, { headers }).pipe(
			map(({ access_token, refresh_token, metadata }) => ({
				requestPoint,
				access_token,
				refresh_token,
				metadata,
			}))
		)
	}
}
